import * as yup from 'yup';

export const validateField = <T extends object>(schema: yup.ObjectSchema<T>, field: keyof T, formState: T): string => {
	try {
		schema.validateSyncAt(field as string, formState);

		return '';
	} catch (error) {
		return (error as yup.ValidationError).message;
	}
};
